<template>
    <div class="color-picker">
        <div class="colors">
            <div class="color" v-for="listColor in colors"
                 :style="{ 'background-color': listColor }"
                 @click="color = listColor">
                <i class="fa fa-check-circle" v-if="color === listColor" aria-hidden="true"></i>
            </div>
        </div>

        <input type="hidden" :value="color"
               :name="name">
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                default: () => {
                    return 'color';
                },
                type: String
            },

            defaultColor: {
                default: () => {
                    return '#FF5733';
                },
                type: String
            },

            colors: {
                default: () => {
                    return [ '#FF5733', '#C70039', '#900C3F', '#581845', '#0C8190', '#3F900C', '#FAC05E' ];
                },
                type: Array
            }
        },

        data(){
            return {
               color: this.defaultColor
            };
        }
    }
</script>
